import { Team as SnapshotTeam, SummonerSpellName as SnapshotSummonerSpellName, DragonType as SnapshotDragonType, Lane, StructureTier, StructureType } from "../snapshot/Enums";
export var Team;
(function (Team) {
    Team["ORDER"] = "ORDER";
    Team["CHAOS"] = "CHAOS";
})(Team || (Team = {}));
(function (Team) {
    function convert(team) {
        switch (team) {
            case Team.ORDER:
                return SnapshotTeam.BLUE;
            case Team.CHAOS:
                return SnapshotTeam.RED;
            default:
                throw new Error("Unknown team: ".concat(team));
        }
    }
    Team.convert = convert;
})(Team || (Team = {}));
export var Position;
(function (Position) {
    Position["NONE"] = "";
    Position["TOP"] = "TOP";
    Position["JUNGLE"] = "JUNGLE";
    Position["MIDDLE"] = "MIDDLE";
    Position["BOTTOM"] = "BOTTOM";
    Position["SUPPORT"] = "UTILITY";
})(Position || (Position = {}));
export var SummonerSpellName;
(function (SummonerSpellName) {
    SummonerSpellName["BARRIER"] = "Barrier";
    SummonerSpellName["CLEANSE"] = "Cleanse";
    SummonerSpellName["EXHAUST"] = "Exhaust";
    SummonerSpellName["FLASH"] = "Flash";
    SummonerSpellName["HEXFLASH"] = "Hexflash";
    SummonerSpellName["GHOST"] = "Ghost";
    SummonerSpellName["HEAL"] = "Heal";
    SummonerSpellName["IGNITE"] = "Ignite";
    SummonerSpellName["SMITE"] = "Smite";
    SummonerSpellName["UNLEASHED_SMITE"] = "Unleashed Smite";
    SummonerSpellName["PRIMAL_SMITE"] = "Primal Smite";
    SummonerSpellName["TELEPORT"] = "Teleport";
    SummonerSpellName["UNLEASHED_TELEPORT"] = "Unleashed Teleport";
})(SummonerSpellName || (SummonerSpellName = {}));
(function (SummonerSpellName) {
    function convert(summonerSpellName) {
        switch (summonerSpellName) {
            case SummonerSpellName.BARRIER:
                return SnapshotSummonerSpellName.BARRIER;
            case SummonerSpellName.CLEANSE:
                return SnapshotSummonerSpellName.CLEANSE;
            case SummonerSpellName.EXHAUST:
                return SnapshotSummonerSpellName.EXHAUST;
            case SummonerSpellName.FLASH:
                return SnapshotSummonerSpellName.FLASH;
            case SummonerSpellName.HEXFLASH:
                return SnapshotSummonerSpellName.FLASH;
            case SummonerSpellName.GHOST:
                return SnapshotSummonerSpellName.GHOST;
            case SummonerSpellName.HEAL:
                return SnapshotSummonerSpellName.HEAL;
            case SummonerSpellName.IGNITE:
                return SnapshotSummonerSpellName.IGNITE;
            case SummonerSpellName.SMITE:
                return SnapshotSummonerSpellName.SMITE;
            case SummonerSpellName.UNLEASHED_SMITE:
                return SnapshotSummonerSpellName.SMITE;
            case SummonerSpellName.PRIMAL_SMITE:
                return SnapshotSummonerSpellName.SMITE;
            case SummonerSpellName.TELEPORT:
                return SnapshotSummonerSpellName.TELEPORT;
            case SummonerSpellName.UNLEASHED_TELEPORT:
                return SnapshotSummonerSpellName.TELEPORT;
            default:
                throw new Error("Unknown summoner spell name: ".concat(summonerSpellName));
        }
    }
    SummonerSpellName.convert = convert;
})(SummonerSpellName || (SummonerSpellName = {}));
export var EventName;
(function (EventName) {
    EventName["GAME_START"] = "GameStart";
    EventName["MINIONS_SPAWNING"] = "MinionsSpawning";
    EventName["CHAMPION_KILL"] = "ChampionKill";
    EventName["DRAGON_KILL"] = "DragonKill";
    EventName["HORDE_KILL"] = "HordeKill";
    EventName["HERALD_KILL"] = "HeraldKill";
    EventName["BARON_KILL"] = "BaronKill";
    EventName["TURRET_KILLED"] = "TurretKilled";
    EventName["INHIB_KILLED"] = "InhibKilled";
})(EventName || (EventName = {}));
export var StructureName;
(function (StructureName) {
    StructureName["TURRET_T1_L_03_A"] = "Turret_T1_L_03_A";
    StructureName["TURRET_T1_L_02_A"] = "Turret_T1_L_02_A";
    StructureName["TURRET_T1_C_06_A"] = "Turret_T1_C_06_A";
    StructureName["BARRACKS_T1_L1"] = "Barracks_T1_L1";
    StructureName["TURRET_T1_C_05_A"] = "Turret_T1_C_05_A";
    StructureName["TURRET_T1_C_04_A"] = "Turret_T1_C_04_A";
    StructureName["TURRET_T1_C_03_A"] = "Turret_T1_C_03_A";
    StructureName["BARRACKS_T1_C1"] = "Barracks_T1_C1";
    StructureName["TURRET_T1_R_03_A"] = "Turret_T1_R_03_A";
    StructureName["TURRET_T1_R_02_A"] = "Turret_T1_R_02_A";
    StructureName["TURRET_T1_C_07_A"] = "Turret_T1_C_07_A";
    StructureName["BARRACKS_T1_R1"] = "Barracks_T1_R1";
    StructureName["TURRET_T2_L_03_A"] = "Turret_T2_L_03_A";
    StructureName["TURRET_T2_L_02_A"] = "Turret_T2_L_02_A";
    StructureName["TURRET_T2_L_01_A"] = "Turret_T2_L_01_A";
    StructureName["BARRACKS_T2_L1"] = "Barracks_T2_L1";
    StructureName["TURRET_T2_C_05_A"] = "Turret_T2_C_05_A";
    StructureName["TURRET_T2_C_04_A"] = "Turret_T2_C_04_A";
    StructureName["TURRET_T2_C_03_A"] = "Turret_T2_C_03_A";
    StructureName["BARRACKS_T2_C1"] = "Barracks_T2_C1";
    StructureName["TURRET_T2_R_03_A"] = "Turret_T2_R_03_A";
    StructureName["TURRET_T2_R_02_A"] = "Turret_T2_R_02_A";
    StructureName["TURRET_T2_R_01_A"] = "Turret_T2_R_01_A";
    StructureName["BARRACKS_T2_R1"] = "Barracks_T2_R1";
    StructureName["TURRET_T1_C_01_A"] = "Turret_T1_C_01_A";
    StructureName["TURRET_T1_C_02_A"] = "Turret_T1_C_02_A";
    StructureName["TURRET_T2_C_01_A"] = "Turret_T2_C_01_A";
    StructureName["TURRET_T2_C_02_A"] = "Turret_T2_C_02_A";
})(StructureName || (StructureName = {}));
(function (StructureName) {
    function convert(structureName) {
        var _a;
        var STRUCTURE_MAP = (_a = {},
            _a[StructureName.TURRET_T1_L_03_A] = [SnapshotTeam.BLUE, Lane.TOP, StructureTier.OUTER, StructureType.TURRET],
            _a[StructureName.TURRET_T1_L_02_A] = [SnapshotTeam.BLUE, Lane.TOP, StructureTier.INNER, StructureType.TURRET],
            _a[StructureName.TURRET_T1_C_06_A] = [SnapshotTeam.BLUE, Lane.TOP, StructureTier.INHIB, StructureType.TURRET],
            _a[StructureName.BARRACKS_T1_L1] = [SnapshotTeam.BLUE, Lane.TOP, StructureTier.NONE, StructureType.INHIB],
            _a[StructureName.TURRET_T1_C_05_A] = [SnapshotTeam.BLUE, Lane.MID, StructureTier.OUTER, StructureType.TURRET],
            _a[StructureName.TURRET_T1_C_04_A] = [SnapshotTeam.BLUE, Lane.MID, StructureTier.INNER, StructureType.TURRET],
            _a[StructureName.TURRET_T1_C_03_A] = [SnapshotTeam.BLUE, Lane.MID, StructureTier.INHIB, StructureType.TURRET],
            _a[StructureName.BARRACKS_T1_C1] = [SnapshotTeam.BLUE, Lane.MID, StructureTier.NONE, StructureType.INHIB],
            _a[StructureName.TURRET_T1_R_03_A] = [SnapshotTeam.BLUE, Lane.BOT, StructureTier.OUTER, StructureType.TURRET],
            _a[StructureName.TURRET_T1_R_02_A] = [SnapshotTeam.BLUE, Lane.BOT, StructureTier.INNER, StructureType.TURRET],
            _a[StructureName.TURRET_T1_C_07_A] = [SnapshotTeam.BLUE, Lane.BOT, StructureTier.INHIB, StructureType.TURRET],
            _a[StructureName.BARRACKS_T1_R1] = [SnapshotTeam.BLUE, Lane.BOT, StructureTier.NONE, StructureType.INHIB],
            _a[StructureName.TURRET_T2_L_03_A] = [SnapshotTeam.RED, Lane.TOP, StructureTier.OUTER, StructureType.TURRET],
            _a[StructureName.TURRET_T2_L_02_A] = [SnapshotTeam.RED, Lane.TOP, StructureTier.INNER, StructureType.TURRET],
            _a[StructureName.TURRET_T2_L_01_A] = [SnapshotTeam.RED, Lane.TOP, StructureTier.INHIB, StructureType.TURRET],
            _a[StructureName.BARRACKS_T2_L1] = [SnapshotTeam.RED, Lane.TOP, StructureTier.NONE, StructureType.INHIB],
            _a[StructureName.TURRET_T2_C_05_A] = [SnapshotTeam.RED, Lane.MID, StructureTier.OUTER, StructureType.TURRET],
            _a[StructureName.TURRET_T2_C_04_A] = [SnapshotTeam.RED, Lane.MID, StructureTier.INNER, StructureType.TURRET],
            _a[StructureName.TURRET_T2_C_03_A] = [SnapshotTeam.RED, Lane.MID, StructureTier.INHIB, StructureType.TURRET],
            _a[StructureName.BARRACKS_T2_C1] = [SnapshotTeam.RED, Lane.MID, StructureTier.NONE, StructureType.INHIB],
            _a[StructureName.TURRET_T2_R_03_A] = [SnapshotTeam.RED, Lane.BOT, StructureTier.OUTER, StructureType.TURRET],
            _a[StructureName.TURRET_T2_R_02_A] = [SnapshotTeam.RED, Lane.BOT, StructureTier.INNER, StructureType.TURRET],
            _a[StructureName.TURRET_T2_R_01_A] = [SnapshotTeam.RED, Lane.BOT, StructureTier.INHIB, StructureType.TURRET],
            _a[StructureName.BARRACKS_T2_R1] = [SnapshotTeam.RED, Lane.BOT, StructureTier.NONE, StructureType.INHIB],
            _a[StructureName.TURRET_T1_C_01_A] = [SnapshotTeam.BLUE, Lane.MID, StructureTier.NEXUS_1, StructureType.TURRET],
            _a[StructureName.TURRET_T1_C_02_A] = [SnapshotTeam.BLUE, Lane.MID, StructureTier.NEXUS_2, StructureType.TURRET],
            _a[StructureName.TURRET_T2_C_01_A] = [SnapshotTeam.RED, Lane.MID, StructureTier.NEXUS_1, StructureType.TURRET],
            _a[StructureName.TURRET_T2_C_02_A] = [SnapshotTeam.RED, Lane.MID, StructureTier.NEXUS_2, StructureType.TURRET],
            _a);
        var details = STRUCTURE_MAP[structureName];
        if (!details) {
            throw new Error("Unknown structure name: ".concat(structureName));
        }
        return details;
    }
    StructureName.convert = convert;
    function isStructure(structureName) {
        return Object.values(StructureName).includes(structureName);
    }
    StructureName.isStructure = isStructure;
    function isTurret(structureName) {
        return structureName.includes('Turret');
    }
    StructureName.isTurret = isTurret;
    function isInhib(structureName) {
        return structureName.includes('Barracks');
    }
    StructureName.isInhib = isInhib;
})(StructureName || (StructureName = {}));
export var DragonType;
(function (DragonType) {
    DragonType["AIR"] = "Air";
    DragonType["EARTH"] = "Earth";
    DragonType["FIRE"] = "Fire";
    DragonType["WATER"] = "Water";
    DragonType["HEXTECH"] = "Hextech";
    DragonType["CHEMTECH"] = "Chemtech";
    DragonType["ELDER"] = "Elder";
})(DragonType || (DragonType = {}));
(function (DragonType) {
    function convert(dragonType) {
        switch (dragonType) {
            case DragonType.AIR:
                return SnapshotDragonType.CLOUD;
            case DragonType.WATER:
                return SnapshotDragonType.OCEAN;
            case DragonType.FIRE:
                return SnapshotDragonType.INFERNAL;
            case DragonType.EARTH:
                return SnapshotDragonType.MOUNTAIN;
            case DragonType.HEXTECH:
                return SnapshotDragonType.HEXTECH;
            case DragonType.CHEMTECH:
                return SnapshotDragonType.CHEMTECH;
            case DragonType.ELDER:
                return SnapshotDragonType.ELDER;
            default:
                throw new Error("Unknown dragon type: ".concat(dragonType));
        }
    }
    DragonType.convert = convert;
})(DragonType || (DragonType = {}));
export var GameMode;
(function (GameMode) {
    GameMode["CLASSIC"] = "CLASSIC";
    GameMode["ARAM"] = "ARAM";
    GameMode["PRACTICE_TOOL"] = "PRACTICETOOL";
})(GameMode || (GameMode = {}));
export var MapTerrain;
(function (MapTerrain) {
    MapTerrain["DEFAULT"] = "Default";
    MapTerrain["CLOUD"] = "Cloud";
    MapTerrain["MOUNTAIN"] = "Mountain";
    MapTerrain["OCEAN"] = "Ocean";
    MapTerrain["INFERNAL"] = "Infernal";
    MapTerrain["HEXTECH"] = "Hextech";
    MapTerrain["CHEMTECH"] = "Chemtech";
})(MapTerrain || (MapTerrain = {}));
export var RuneTree;
(function (RuneTree) {
    RuneTree["DOMINATION"] = "Domination";
    RuneTree["INSPIRATION"] = "Inspiration";
    RuneTree["PRECISION"] = "Precision";
    RuneTree["RESOLVE"] = "Resolve";
    RuneTree["SORCERY"] = "Sorcery";
})(RuneTree || (RuneTree = {}));
export var RuneKeystone;
(function (RuneKeystone) {
    RuneKeystone["DARK_HARVEST"] = "Dark Harvest";
    RuneKeystone["ELECTROCUTE"] = "Electrocute";
    RuneKeystone["HAIL_OF_BLADES"] = "Hail of Blades";
    RuneKeystone["FIRST_STRIKE"] = "First Strike";
    RuneKeystone["GLACIAL_AUGMENT"] = "Glacial Augment";
    RuneKeystone["UNSEALED_SPELLBOOK"] = "Unsealed Spellbook";
    RuneKeystone["CONQUEROR"] = "Conqueror";
    RuneKeystone["FLEET_FOOTWORK"] = "Fleet Footwork";
    RuneKeystone["PRESS_THE_ATTACK"] = "Press the Attack";
    RuneKeystone["AFTERSHOCK"] = "Aftershock";
    RuneKeystone["GRASP_OF_THE_UNDYING"] = "Grasp of the Undying";
    RuneKeystone["GUARDIAN"] = "Guardian";
    RuneKeystone["ARCANE_COMET"] = "Arcane Comet";
    RuneKeystone["PHASE_RUSH"] = "Phase Rush";
    RuneKeystone["SUMMON_AERY"] = "Summon Aery";
})(RuneKeystone || (RuneKeystone = {}));
